import React, { useState } from 'react';
import { Provider } from '.';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';
import { ModalBody, ModalFooter } from '../../../../components/Modal/styles';
import Icon from '../../../../components/Section/Icon';
import { getInfoMessage } from './CollapsibleProvider';
import { ConfirmDisassociateInfo } from './styles';

type Props = {
  provider: Provider;
  removeProvider: (provider: Provider) => Promise<void>;
  openConfirmDisassociateModal: any;
  setOpenConfirmDisassociateModal: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

const ConfirmDisassociate = ({
  provider,
  removeProvider,
  openConfirmDisassociateModal,
  setOpenConfirmDisassociateModal,
}: Props) => {
  const [disabled, setDisabled] = useState<boolean>(false);

  const disassociateProvider = async () => {
    if (disabled) {
      return;
    }

    setDisabled(true);
    try {
      await removeProvider(provider);
    } catch {
      setDisabled(false);
    }
  };

  return (
    <>
      {openConfirmDisassociateModal && (
        <Modal
          header={`Desassociar ${provider.name}`}
          closeButton={() => setOpenConfirmDisassociateModal(false)}
        >
          <ModalBody>
            <ConfirmDisassociateInfo>
              <Icon svg={provider.image} alt={`${provider.name}-icon`} />
              {getInfoMessage(provider).confirmDelete}
            </ConfirmDisassociateInfo>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="primary"
              onClick={() => setOpenConfirmDisassociateModal(false)}
            >
              Cancelar
            </Button>
            <Button variant="secondary" onClick={disassociateProvider}>
              Desassociar
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default ConfirmDisassociate;
